module.exports = __webpack_public_path__ + "img/new_gzh_second.9549fbd5.png";